import axios from "axios";
import contracts from "../contracts/contracts.json";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const C = contracts;
const TOKEN_KEY = "pfp_access_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: BACKEND_URL, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errorMessage(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d.replace(/_/g, " ").toLowerCase();
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d.detail === "string") return d.detail; // {code, detail} — the server's own wording reads better
  if (typeof d.code === "string") return d.code.replace(/_/g, " ").toLowerCase();
  return String(d);
}

export const wsUrl = (tableId) =>
  `${BACKEND_URL.replace(/^http/, "ws")}${C.ApiRoutes.WS_TABLE.replace("{table_id}", tableId)}?token=${encodeURIComponent(getToken() || "")}`;

// Cash is money on the table and reads with a $; tournament chips are chips, and read bare.
let chipPrefix = "$";
export const setChipPrefix = (p) => { chipPrefix = p; };
export const fmtChips = (n) => `${chipPrefix}${Number(n || 0).toLocaleString()}`;
